import React, { Fragment, useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { downloadBlobFromResponse } from "../../Scripts/FileUtilities";
import Layout from './Layout';
import Home from './Home';
import ModalComponent from '../Common/ModalComponent'
import { handleSignIn } from '../../Scripts/SignIn';
import B2RFolderTreeview from './B2RFolderTreeview';
import DocList from './DocList';
import SectionHeader, { SectionHeaderTypes } from '../Common/SectionHeader'
import SectionHeaderWithIcon from '../Common/SectionHeaderWithIcon';
import useExecFunctionOnBackButton from '../Common/useExecFunctionOnBackButton';
import Loading from '../Common/Loading';

export default function B2RContainer() {
    const [useSuperSync, setUseSuperSync] = useState(true);
    const [buildZipLocally, setBuildZipLocally] = useState(true);
    const location = useLocation();
    const [selectedMenuData, setSelectedMenuData] = useState({ selectedMenu: '', selectedOn: new Date() });
    const [loggedInUser, setLoggedInUser] = useState({ loading: true });
    const [searchTerms, setSearchTerms] = useState("");
    const [b2rProjects, setB2rProjects] = useState({ projects: undefined, loading: false });
    const [selectedProject, setSelectedProject] = useState();
    const [selectedFolderInfo, setSelectedFolderInfo] = useState({ selectedFolder: undefined, stickySelectedFolderId: undefined, isDefault:false , docReferenceIds: [] });
    const documentsDefaultValues = { documentList: [], selectedDocuments: [], loading: false, filtered: false, selectedCount: 0, allSelected: false, sortBy: 'created', sortOrder: 'desc' };
    const [documents, setDocuments] = useState(documentsDefaultValues);
    const [downloadDocsProgress, setDownloadDocsProgress] = useState({ totalBatches: 1, completedBatches: 1, isDownloadCompleted: true, isSingleDocument: false });
    const abortDownloadRef = useRef(undefined);
    const [isSessionExpired, setIsSessionExpired] = useState();
    const batchMaxSize = 0; /*Use 0 for no batches*/
    var downloadDocsTimeoutId = undefined;
/*check*/    useEffect(() => handleGetLoggedUserB2RProjects(loggedInUser), [selectedMenuData, loggedInUser]);

    const navigate = useNavigate();
    const navigateRef = useRef(navigate);
    useEffect(() => handleGetLoggedInUser(), []);

    const handleBackButton = useCallback(() => {
        if (selectedProject === undefined) {
            window.history.go(1);
            navigateRef.current('/');
        }
    }, [selectedProject]);
    useExecFunctionOnBackButton(handleBackButton);

    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    const dateFormatterForSearch = new Intl.DateTimeFormat('en-US', { weekday: "long", year: "numeric", month: "long", day: "2-digit" });
    const dateRegex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/(\d{4}|\d{2})$/;

    function handleNavigationClick(selectedMenu) {
        setSelectedMenuData({ selectedMenu, selectedOn: new Date() });
    }

    function handleGetLoggedInUser() {
        var url = 'User/GetLoggedInUser';
        var requestInit = { method: 'POST', headers: { 'Content-type': 'application/json' } };

        setLoggedInUser({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setLoggedInUser({ loading: false, ...data });
                if (data?.isAuthenticated && data?.isDocShareUser) {
                    navigateRef.current('/b2r');
                    setSelectedMenuData({ selectedMenu: "b2r", selectedOn: new Date() });
                }
            })
            .catch(e => {
                // handle error here.
                setLoggedInUser({ loading: false });
                console.log(e);
            });
    }

    function handleGetLoggedUserB2RProjects(loggedInUser) {
        if (!loggedInUser.isAuthenticated) { return; }

        var url = 'B2R/GetLoggedInUserProjects';
        var requestInit = { method: 'POST', headers: { 'Content-type': 'application/json' }, };
        setB2rProjects({ projects: [], loading: true });
        setSelectedProject(undefined);
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                return Promise.reject(response);
            })
            .then(data => {
                setB2rProjects({ projects: data, loading: false })
            })
            .catch(e => {
                // handle error here.
                console.log(e);
                if (e.status === 401) {
                    setIsSessionExpired(true);
                    // window.location.reload(true);
                }
                else {
                    setB2rProjects({ projects: [], loading: false });
                }
            });
    }

    function handleSelectProject(proj) {
        //let referenceIds = proj.documentIds;
        let projectId = proj.projectId;

        let url = `B2R/GetDocumentsInfo/${projectId}`;
        let requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };
        setSelectedProject(proj);
        setSearchTerms('');
        //handleUnselectFolder();
        handleSelectFolder("showAll", true);
        setDocuments({ ...documentsDefaultValues, loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                return Promise.reject(response);
            })
            .then(data => {
                let documentList = data.map(doc => { return { selected: false, shown: true, ...doc } });
                let comparer = (a, b) => a.folderPath.localeCompare(b.folderPath);
                documentList.sort(comparer);
                setDocuments(prevState => ({ ...prevState, documentList: documentList, loading: false }));

                /*Set all docIds as part of the "showAll" filter---------*/
                let docReferenceIds = documentList.map(doc => doc.referenceId);
                setSelectedFolderInfo(prevState => ({ ...prevState, docReferenceIds: docReferenceIds }));
                /*---------Set all docIds as part of the "showAll" filter*/
            })
            .catch(e => {
                // handle error here.
                console.log(e);
                if (e.status === 401) {
                    setIsSessionExpired(true);
                    // window.location.reload(true);
                }
                else {
                    setDocuments(prevState => ({ ...prevState, loading: false }));
                }
            });
    }

    function handleUnselectFolder(stickySelectedFolderId) {
        setSelectedFolderInfo({ selectedFolder: undefined, stickySelectedFolderId: stickySelectedFolderId, isDefault: false, docReferenceIds: [] });
    }

    function handleSelectFolder(folder, isDefault=false) {
        let docReferenceIds = [];
        if (folder === "showAll") {
            folder = { id: "showAll" };
            docReferenceIds = documents.documentList.map(doc => doc.referenceId);
        }
        else {
            docReferenceIds = folder.documentIds;
        }

        handleUnselectDocs();
        setSelectedFolderInfo({ selectedFolder: folder, stickySelectedFolderId: folder.id, isDefault: isDefault, docReferenceIds: docReferenceIds });
    }

    function handleDownloadBatches(batchIndex = 0) {
        let totalBatches = documents.selectedDocuments.length;
        setDownloadDocsProgress({ totalBatches: totalBatches, completedBatches: batchIndex, isDownloadCompleted: false, isSingleDocument: false });

        let abortController = new AbortController(); // Create a new abort controller for each batch
        abortDownloadRef.current = abortController; // Set it to the ref

        if (batchIndex < totalBatches) {
            downloadBatch(batchIndex, totalBatches, abortController.signal)
                .then(() => {
                    return handleDownloadBatches(batchIndex + 1);
                })
                .catch(error => {
                    abortController.abort();
                    handleAbortDownload();
                });
        }
        else {
            handleDownloadFinished(totalBatches, batchIndex);
        }

        // abortDownload.abort();
    }

    function handleDownloadFinished(totalBatches = 1, completedBatches = 1) {
        clearTimeout(downloadDocsTimeoutId);
        downloadDocsTimeoutId = setTimeout(() =>
            setDownloadDocsProgress({ totalBatches: totalBatches, completedBatches: completedBatches, isDownloadCompleted: true, isSingleDocument: false }),
            350);
    }

    function handleAbortDownload() {
        if (abortDownloadRef.current) {
            abortDownloadRef.current.abort();
        }
        handleDownloadFinished();
    }

    function downloadBatch(batchIndex, batchQty, abortSignal) {
        let batch = documents.selectedDocuments[batchIndex];
        if (batch.batchSize <= 0 || batch.refIds.length <= 0) {
            //TODO: handle no files selected.
            return Promise.reject(new Error("No files selected"));
        }
        
        let referenceIds = batch.refIds;

        let url = `B2R/GetDocuments/${batchIndex + 1}/${batchQty}/${selectedProject.projectName}/${buildZipLocally}/${useSuperSync}`;
        let requestInit = { method: 'POST', headers: { 'Content-type': 'application/json' }, body: JSON.stringify(referenceIds), signal: abortSignal };


        return fetch(url, requestInit)
            .then(response => {
                if (response.ok) {
                    return downloadBlobFromResponse(response);
                }
                return Promise.reject(response);
            })
            .catch(e => {
                // handle error here.
                console.log(e);
                if (e.status === 401) {
                    setIsSessionExpired(true);
                    // window.location.reload(true);
                }
                // if (e.aborted) { }
                throw e; // Re-throw the error to be caught by the calling function
            });
    }

    function handleDownloadDocs() {
        let referenceIds;
        if (documents.selectedCount > 0) {
            referenceIds = documents.documentList.filter(x => x.selected).map(x => x.referenceId);
        }
        else {
            referenceIds = documents.documentList.map(x => x.referenceId);
        }

        if (referenceIds.length === 0) {
            //TODO: handle no files selected.
            return;
        }

        let url = 'B2R/GetDocuments';
        let requestInit = { method: 'POST', headers: { 'Content-type': 'application/json' }, body: JSON.stringify(referenceIds) };

        fetch(url, requestInit)
            .then(response => {
                if (response.ok) {
                    return downloadBlobFromResponse(response);
                }
                return Promise.reject(response);
            })
            .catch(e => {
                // handle error here.
                console.log(e);
                if (e.status === 401) {
                    setIsSessionExpired(true);
                    // window.location.reload(true);
                }
            });
    }

    function handleDownloadDoc(documentId) {
        let url = `B2R/GetDocument/${documentId}`;
        let requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setDownloadDocsProgress({ totalBatches: 1, completedBatches: 1, isDownloadCompleted: false, isSingleDocument: true });

        fetch(url, requestInit)
            .then(response => {
                if (response.ok) {
                    return downloadBlobFromResponse(response).then(handleDownloadFinished);
                }
                return Promise.reject(response);
            })
            .catch(e => {
                // handle error here.
                console.log(e);
                handleDownloadFinished();
                if (e.status === 401) {
                    setIsSessionExpired(true);
                    // window.location.reload(true);
                }
            });
    }

    function handleUnselectDocs() {
        setDocuments(prevState => {
            let documentList = prevState.documentList.map(doc => {
                doc.selected = false;
                return doc;
            });

            let selectedDocuments = createSelectedDocumentBatches(batchMaxSize, documentList);

            return { ...prevState, documentList: documentList, selectedDocuments: selectedDocuments, allSelected: false, loading: false, selectedCount: 0 };
        });
    }

    function handleSelectAllDocs() {
        setDocuments(prevState => {
            let allSelected = !prevState.allSelected;

            let selectedCount = 0;
            let documentList = prevState.documentList.map(doc => {
                if (allSelected && (selectedFolderInfo.selectedFolder.id === "showAll" || selectedFolderInfo.docReferenceIds.includes(doc.referenceId))) {
                    doc.selected = true;
                }
                else {
                    doc.selected = false;
                }

                if (doc.selected) { ++selectedCount; }

                return doc;
            });

            let selectedDocuments = createSelectedDocumentBatches(batchMaxSize, documentList);

            return { ...prevState, documentList: documentList, allSelected, selectedDocuments: selectedDocuments, loading: false, selectedCount: selectedCount };
        });
    }

    function handleSelectDoc(referenceId) {
        setDocuments(prevState => {
            let selectedCount = 0;
            let documentList = prevState.documentList.map(doc => {
                if (doc.referenceId === referenceId) {
                    doc.selected = !doc.selected
                }
                if (doc.selected) { ++selectedCount; }

                return doc;
            });

            let selectedDocuments = createSelectedDocumentBatches(batchMaxSize, documentList);

            let allSelected = selectedCount === selectedFolderInfo.docReferenceIds.length;

            return { ...prevState, documentList: documentList, allSelected, selectedDocuments: selectedDocuments, loading: false, selectedCount: selectedCount };
        });
    }

    function createSelectedDocumentBatches(batchMaxSize, documentList) {
        let batches = documentList.filter(x => x.selected === true).reduce((acc, cv, i, arr) => {
            if (acc.length === 0 || (batchMaxSize > 0 && acc[acc.length - 1].batchSize >= batchMaxSize)) {
                acc.push({ batchWeight: 0, batchSize: 0, refIds: [] });
            }
            let currentBatch = acc[acc.length - 1];
            currentBatch.batchWeight += (cv.fileSize / 1024 / 1024);
            currentBatch.batchSize++;
            currentBatch.refIds.push(cv.referenceId)
            return acc;
        }, []);

        return batches;
    }

    function handleKeyUpSearchTerms(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            handleFindDocs();
        }
    }

    function handleChangeSearchTerms(e) {
        setSearchTerms(e.target.value);
    }

    function handleCancelSearch() {
        setSearchTerms('');
        let selectedCount = 0;
        let docList = documents.documentList.map(doc => {
            // show all.
            doc.shown = true;

            // new count of selected documents.
            // if (doc.selected) { ++selectedCount; }
            doc.selected = false;

            return doc;
        });

        setDocuments(prevState => ({ ...prevState, documentList: docList, selectedDocuments: [], loading: false, filtered: false, selectedCount: selectedCount, allSelected: false }));
    }

    function handleFindDocs() {
        let selectedCount = 0;
        handleFindFolders();
        let docList = documents.documentList.map(doc => {
            // mark found documents as shown.
            let foundInName = doc.name.toLowerCase().includes(searchTerms.trim().toLowerCase());
            let foundInDate = false;
            if (dateRegex.test(searchTerms) && isNaN(Date.parse(searchTerms)) === false && isNaN(Date.parse(doc.fileCreated)) === false) {
                foundInDate = dateFormatter.format(new Date(doc.fileCreated)) === dateFormatter.format(new Date(searchTerms));
            }
            else {
                foundInDate = `${dateFormatterForSearch.format(new Date(doc.fileCreated))} ${dateFormatter.format(new Date(doc.fileCreated))}`.includes(searchTerms);
            }

            doc.shown = foundInName || foundInDate;

            // hidden documents are unselected.
            if (!doc.shown) { doc.selected = false; }

            // new count of selected documents.
            // if (doc.selected) { ++selectedCount; }
            doc.selected = false;

            return doc;
        });

        let filtered = searchTerms !== '';

        setDocuments(prevState => ({ ...prevState, documentList: docList, selectedDocuments: [], loading: false, filtered: filtered, selectedCount: selectedCount, allSelected: false }));
    }

    function handleSortDocs(sortBy, sortOrder) {
        if (sortOrder !== 'desc' && sortOrder !== 'asc') {
            sortOrder = 'desc';
        }
        // sortOrder = sortBy !== documents.sortBy ? "desc" : documents.sortOrder === "desc" ? "asc" : "desc";

        let isDesc = sortOrder === "desc";
        let compareFn = undefined;
        switch (sortBy?.toLowerCase()) {
            case 'id':
                compareFn = (a, b) => (isDesc ? b.referenceId - a.referenceId : a.referenceId - b.referenceId);
                break;
            case 'filesize':
                compareFn = (a, b) => (isDesc ? b.fileSize - a.fileSize : a.fileSize - b.fileSize);
                break;
            case 'name':
                compareFn = (a, b) => (isDesc ? ('' + b.name).localeCompare(a.name) : ('' + a.name).localeCompare(b.name));
                break;
            case 'modified':
                sortBy = "modified";
                compareFn = (a, b) => {
                    const timeA = new Date(a.fileModified).getTime();
                    const timeB = new Date(b.fileModified).getTime();
                    return isDesc ? timeB - timeA : timeA - timeB;
                };
                break;
            case 'created':
            default:
                sortBy = "created";
                compareFn = (a, b) => {
                    const timeA = new Date(a.fileCreated).getTime();
                    const timeB = new Date(b.fileCreated).getTime();
                    return isDesc ? timeB - timeA : timeA - timeB;
                };
                break;
        }

        let docList = documents.documentList.toSorted(compareFn);

        setDocuments(prevState => ({ ...prevState, documentList: docList, sortBy: sortBy, sortOrder: sortOrder }));
    }

    function handleFindFolders() {
        const applyFilter = function (folder) {
            folder.isFound = folder.folderName.toLowerCase().includes(searchTerms.trim().toLowerCase());
            folder.folders.map(x => applyFilter(x));
        };

        let rootFolder = { ...selectedProject.folder };
        applyFilter(rootFolder);
        setSelectedProject({ ...selectedProject, folder: rootFolder });
    }

    function handleUnselectProject() {
        //setSelectedProject(undefined);
        handleGetLoggedUserB2RProjects(loggedInUser);
        setSearchTerms('');
        handleUnselectFolder();
        setDocuments(documentsDefaultValues);
    }

    let content;
    if (!loggedInUser.isAuthenticated) {
        // Not authenticated:
        content = (<Home loggedInUser={loggedInUser} />);
    }
    else {
        if (!loggedInUser.isDocShareUser) {
            // Authenticated but not Docshare user:
        }
        else {
            // Authenticated and Docshare user:
            /*Project List-------------*/
            let projectItems;
            if (b2rProjects.loading) {
                projectItems = (<Loading loadingMessage="Loading your projects." />);
            }
            else if (b2rProjects.projects) {
                if (b2rProjects.projects.length === 0) {
                    projectItems = (<div className="centeredMessage"><h2>No projects available.</h2></div>);
                }
                else {
                    let projects = b2rProjects.projects.map(proj => {
                        //let docQty = proj.documentIds?.length || 0;
                        //let viewBtn = docQty <= 0 ? "No Docs" : (<button name="view" onClick={() => handleSelectProject(proj)}>View</button>);

                        let rootFolder = proj.folder;
                        let viewBtn = rootFolder === undefined ? "No Docs" : (<button name="view" onClick={() => handleSelectProject(proj)}>View</button>);
                        return (<Fragment key={proj.projectId}>
                            <span className="projectCode">{proj.projectCode}</span>
                            <span className="projectName">{proj.projectName}</span>
                            <span className="city">{proj.city}</span>
                            <span className="state">{proj.state}</span>
                            <span className="county">{proj.county} County</span>
                            <span className="units">{`${proj.numberOfUnits} Unit${proj.numberOfUnits === 1 ? "" : "s"}`}</span>
                            <div className="projectDetails">
                                <span className="projectName smallScreen">
                                    <span className="projectCode">{proj.projectCode} </span>
                                    {proj.projectName}
                                </span>
                                <span className="cityState smallScreen">{proj.city} {proj.state}</span>
                                <span className="county smallScreen">{proj.county} County</span>
                                <span className="units smallScreen">{`${proj.numberOfUnits} Unit${proj.numberOfUnits === 1 ? "" : "s"}`}</span>
                            </div>
                            <span className="view">{viewBtn}</span>
                        </Fragment>);
                    });

                    projectItems = (<div className="project">
                        <span className="projectName font-semibold">Project Number</span>
                        <span className="projectName font-semibold">Name</span>
                        <span className="city font-semibold">City</span>
                        <span className="state font-semibold">State</span>
                        <span className="county font-semibold">County</span>
                        <span className="units font-semibold">Projected B2R Units</span>
                        <div className="hidden" />
                        <span className="projectName font-semibold"></span>
                        {projects}
                    </div>);
                }
            }

            let projectList = (<>
                <SectionHeaderWithIcon sectionName="Projects" sectionIcon="dhicon-multi-house" sectionHeaderType={SectionHeaderTypes.Primary} classes="" />
                <div className="projectList">
                    {projectItems}
                </div>
            </>);
            /*-------------Project List*/

            /*Selected Project-------------*/
            let project = selectedProject && (<div className="projectHeader">
                <div style={{ textAlign: 'center' }} >
                    <div>{selectedProject.projectCode}</div>
                    <div className="projectName">{selectedProject.projectName}</div>
                    <div>{`${selectedProject.city}, ${selectedProject.state}`}</div>
                    <div>{`${selectedProject.numberOfUnits} Unit${selectedProject.numberOfUnits === 1 ? "" : "s"}`}</div>
                </div>
            </div>);
            /*-------------Selected Project*/

            /*Search Bar-------------*/
            let searchBar = (<div className="searchBarContainer font-normal">
                {(searchTerms !== '' || documents.filtered) && (<i className="searchIcon dhicon-cancel-circled" onClick={handleCancelSearch} />)}
                <i className="searchIcon dhicon-search" onClick={handleFindDocs} />
                <input type="text" className="searchBar" placeholder="Find a document" value={searchTerms} onChange={handleChangeSearchTerms} onKeyUp={handleKeyUpSearchTerms} />
            </div>);
            /*-------------Search Bar*/

            /*Button Container-------------*/
            let downloadButton = documents.selectedCount > 0 ? (<button name="download" onClick={() => handleDownloadBatches(0)}>Download</button>) : (<div></div>);

            let unselectFolder = selectedFolderInfo.selectedFolder && !selectedFolderInfo.isDefault && (<button id="unselectFolder" onClick={() => handleUnselectFolder(selectedFolderInfo.stickySelectedFolderId)}>Back</button>);

            let buttonContainer = !documents?.loading && (<div className="buttonContainer">
                {downloadButton}
                <div className="buttonGroup">
                    {unselectFolder}
                    <button id="unselectProject" onClick={handleUnselectProject}>Done</button>
                </div>
            </div>);
            /*-------------Button Container*/

            let docListingBar = (<SectionHeaderWithIcon classes="docListingBar justify-between" sectionHeaderType={SectionHeaderTypes.Primary} sectionIcon="dhicon-docs" sectionName="Documents" truncateName={true} >
                {searchBar}
            </SectionHeaderWithIcon>);

            /*Folder Container-------------*/
            //let shownDocuments = documents.documentList.filter(x => x.shown);
            //let folderContainer = (<div id="folderContainerHere"></div>);
            let foldersAndDocsContainer;
            if (documents.loading) {
                foldersAndDocsContainer = (<Loading loadingMessage="Loading your documents." />);
            }
            else if (documents.documentList.length <= 0) {
                foldersAndDocsContainer = (<div className="centeredMessage"><h2>No documents available.</h2></div>);
            }
            else if (documents.documentList.length > 0) {
                let rootFolder = selectedProject?.folder && (<B2RFolderTreeview showAll={true}
                    folder={selectedProject.folder}
                    selectedFolderId=/*{selectedFolderInfo.selectedFolder?.id}*/{selectedFolderInfo.stickySelectedFolderId}
                    documentList={documents.documentList}
                    onSelectFolder={handleSelectFolder}
                    onSelectAll={() => handleSelectFolder("showAll")} />);

                let folderContainer = (<div className="rootFolderTreeview">
                    {rootFolder}
                </div>);

                let documentsToShow;
                let currentFolder;
                if (selectedFolderInfo.selectedFolder) {
                    let filteredDocuments = documents.documentList.filter(doc =>
                        (selectedFolderInfo.selectedFolder.id === "showAll" || selectedFolderInfo.selectedFolder.documentIds.includes(doc.referenceId)) &&
                        (doc.shown || selectedFolderInfo.selectedFolder.isFound));
                    documentsToShow = filteredDocuments.length > 0 && (<DocList folderId={selectedFolderInfo.selectedFolder.id}
                        documentList={filteredDocuments}
                        selected={documents.allSelected}
                        sortBy={documents.sortBy}
                        sortOrder={documents.sortOrder}
                        onSelectDoc={handleSelectDoc}
                        onSelectAllDocs={handleSelectAllDocs}
                        onDownloadDoc={handleDownloadDoc}
                        onSortDocs={handleSortDocs}
                        onUnselectProject={handleUnselectProject} />);

                    //--Temporary SuperSync switch---------------
                    const superSyncSwitch = () => setUseSuperSync(!useSuperSync);
                    let docMgmtIcon = !useSuperSync && (<i className="dhicon-check-mark-4 relative -top-[5px] -left-[7px]" />);
                    docMgmtIcon = undefined;

                    const buildZipLocallySwitch = () => setBuildZipLocally(!buildZipLocally);
                    let buildZipLocallyIcon = buildZipLocally && (<i className="dhicon-check-mark-4 relative text-[1.75rem] -top-2.5 -left-2.5" />);
                    let buildZipLocallyContainer = (<div className="w-5 h-5 bg-drhPalette-primary relative ml-1" onClick={buildZipLocallySwitch}>{buildZipLocallyIcon}</div>);
                    buildZipLocallyContainer = undefined;
                    //---------------Temporary SuperSync switch--

                    currentFolder = (<SectionHeader classes="currentFolderHeader m-1">
                        <i className="dhicon-project-documents-option-3 text-lg leading-5" onClick={superSyncSwitch}>
                            <div className="w-2.5 h-[.41rem] bg-drhPalette-secondary relative -top-[.66rem] left-2 -skew-x-[23deg]">
                                {docMgmtIcon}
                            </div>
                        </i>
                        <span className="truncate">{selectedFolderInfo.selectedFolder.id === "showAll" ? "All Documents" : selectedFolderInfo.selectedFolder.folderName}</span>
                        {buildZipLocallyContainer}
                    </SectionHeader>);
                }

                let isFolderSelectedClass = selectedFolderInfo.selectedFolder && !selectedFolderInfo.isDefault ? " folderSelected" : "";
                foldersAndDocsContainer = (<div className={`foldersAndDocsContainer${isFolderSelectedClass}`}>
                    {folderContainer}
                    <div className="documents">{currentFolder}{documentsToShow}</div>
                </div>);
            }
            
            /*-------------Folder Container*/

            /*Documents Pane-------------*/
            let documentsPane = selectedProject && (<div className="documentsPane">
                {project}
                {docListingBar}
                {foldersAndDocsContainer}
                {buttonContainer}
            </div>);
            /*-------------Documents Pane*/

            /*Expired Session-------------*/
            var locationPath = location.pathname;
            let expiredSession = isSessionExpired && (<ModalComponent>
                <h5 className="font-bold">Your session has ended.</h5>
                <div className="buttonContainer">
                    <button className="button" onClick={() => handleSignIn(locationPath)}>Refresh you session here</button>
                </div>
            </ModalComponent>);
            /*-------------Expired Session*/

            /*Download Files Modal-------------*/
            let isSingleDocument = downloadDocsProgress.isSingleDocument;
            let completedBatches = downloadDocsProgress.completedBatches;
            let totalBatches = downloadDocsProgress.totalBatches;
            let progressValue = 100 * (completedBatches + 1) / (totalBatches + 1);

            let waiting = isSingleDocument === false && totalBatches > 1 ? (<>
                <br />
                <h5>Getting batch {Math.min(completedBatches + 1, totalBatches)} of {totalBatches}.</h5>
                <div className="progress">
                    <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                        style={{ width: `${progressValue}%` }} aria-valuenow={progressValue}
                        aria-valuemin="0" aria-valuemax="100">
                    </div>
                </div>
            </>) : (<div className="spinnerContainer"><i className="dhicon-spin5 animate-spin" /></div>);

            let downloadingMessage = isSingleDocument ? "Downloading your document." : `Downloading ${documents.selectedCount} document${documents.selectedCount > 1 ? "s" : ""}.`;
            let zippingMessage = isSingleDocument ? undefined : (<><br /><h5>Please wait, I'm zipping up your document{documents.selectedCount > 1 ? "s" : ""}.</h5></>);

            let downloadFilesModal = !downloadDocsProgress.isDownloadCompleted && (<ModalComponent>
                <h4 className="font-bold">{downloadingMessage}</h4>
                {zippingMessage}
                {waiting}
                <div className="buttonContainer">
                    <button className="button" onClick={handleAbortDownload}>Cancel</button>
                </div>
            </ModalComponent>);
            /*-------------Download Files Modal*/
            content = (<>
                <div className="b2rContainer flex flex-col ">{projectList}{documentsPane}</div>
                {expiredSession}
                {downloadFilesModal}
            </>);
        }
    }

    return (<Layout
        onNavigationClick={handleNavigationClick}
        selectedMenu={selectedMenuData.selectedMenu}
        loggedInUser={loggedInUser}>
        {content}
    </Layout>);
}